import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { FiEdit, FiCalendar, FiPlus } from "react-icons/fi";
import AddProjectModal from "../../modals/admin-dashboard/AddProjectModal";
import LeaveRequestModal from "../../modals/admin-dashboard/LeaveRequestModal";
import { CiCirclePlus } from "react-icons/ci";

// import AddProjectModal from "./AddProjectModal";
// import LeaveRequestModal from "./LeaveRequestModal";

export default function UserWelcomeCard() {
  const [showProject, setShowProject] = useState(false);
  const [showLeave, setShowLeave] = useState(false);

  return (
    <>
      <div>
        <Card className="border-0 shadow-sm welcome-card mb-3">
          <Card.Body className="d-flex align-items-center justify-content-between flex-wrap">
            <div className="d-flex align-items-center mb-3">
              <img
                src="/assets/img/profiles/avatar-31.jpg"
                className="rounded-circle"
                width="60"
              />

              <div className="ms-3">
                <h4 className="mb-1">
                  Welcome Back, Adrian
                  <FiEdit className="ms-2 text-muted" size={14} />
                </h4>

                <p className="mb-0 text-muted">
                  You have
                  <span style={{ color: "#ff6b1a" }} className=" ms-1 me-1">
                    21
                  </span>
                  Pending Approvals &
                  <span style={{ color: "#ff6b1a" }} className=" ms-1 me-1">
                    14
                  </span>
                  Leave Requests
                </p>
              </div>
            </div>

            <div className="d-flex flex-wrap">
              <Button
                variant="light"
                className="me-2 mb-2"
                onClick={() => setShowProject(true)}
              >
                <FiCalendar className="me-1 mb-1" />
                Add Schedule
              </Button>

              <Button
                style={{ backgroundColor: "#f26522" }}
                // variant="primary"
                className="mb-2 border-0"
                onClick={() => setShowLeave(true)}
              >
                {/* <FiPlus  /> */}
                <CiCirclePlus    className="me-1 mb-1" />
                Add Requests
              </Button>
            </div>
          </Card.Body>
        </Card>

        {/* Modals */}

        <AddProjectModal
          showProject={showProject}
          setShowProject={setShowProject}
        />

        <LeaveRequestModal showLeave={showLeave} setShowLeave={setShowLeave} />
        <style>
          {`
          
          .calendar-icon{
position:absolute;
right:12px;
top:10px;
color:#6c757d;
}

.react-datepicker-wrapper{
width:100%;
}

// button.btn-primary{
// background:#f26522;
// border:none;
// }

button.btn-primary:hover{
background:#e55612;
}
          
          `}
        </style>
      </div>
    </>
  );
}
